module.exports = __webpack_public_path__ + "static/media/imagenes.b342267d.svg";